import React from "react";
import { Col, Row, Avatar, List } from "antd";

const tableData = [
  {
    notificationHeading: (
      <div>
        <a href="/vendors/562">Champion Pest Solutions</a>
        Vendor insurance for expires today
      </div>
    ),
    notificationDate: "01/19/2023",
    icon: <i className="fa-solid fa-triangle-exclamation"></i>,
  },
  {
    notificationHeading: (
      <div>
        <a href="/vendors/562">Champion Pest Solutions</a>
        Vendor insurance for expires today
      </div>
    ),
    notificationDate: "01/19/2023",
    icon: <i className="fa-solid fa-triangle-exclamation"></i>,
  },
  {
    notificationHeading: <a href="/vendors/562">Activity due</a>,
    notificationDate: "01/19/2023",
    icon: <i className="fa-solid fa-clipboard"></i>,
  },
  {
    notificationHeading: (
      <div>
        <a href="/vendors/562">Champion Pest Solutions</a>
        Vendor insurance for expires today
      </div>
    ),
    notificationDate: "01/19/2023",
    icon: <i className="fa-solid fa-triangle-exclamation"></i>,
  },
];
const Notifications = () => {
  return (
    <div className="Notifications">
      <div className="dshbrd_acrdn">
        <p>Activities</p>
        <Row>
          <Col span={12}>
            <div className="collected">
              <span className="widget-info-box__datum">0</span>
              <h2 className="widget-info-box__description">
                Due in the next 7 days
              </h2>
            </div>
          </Col>
          <Col span={11} offset={1}>
            <div className="overdue">
              <div className="collected">
                <span className="widget-info-box__datum alert">1</span>
                <h2 className="widget-info-box__description alert">Overdue</h2>
              </div>
            </div>
          </Col>
        </Row>
        <p>Bills</p>
        <Row>
          <Col span={24}>
            <div className="collected">
              <span className="widget-info-box__datum">0</span>
              <h2 className="widget-info-box__description">Pending approval</h2>
            </div>
          </Col>
        </Row>
        <p>Purchase Orders</p>
        <Row>
          <Col span={12}>
            <div className="collected">
              <span className="widget-info-box__datum">0</span>
              <h2 className="widget-info-box__description">
                Pending my approval
              </h2>
            </div>
          </Col>
          <Col span={11} offset={1}>
            <div className="overdue">
              <div className="collected">
                <span className="widget-info-box__datum">0</span>
                <h2 className="widget-info-box__description">
                  Pending approval
                </h2>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <p>Notifications Feed</p>
          </Col>
          <Col span={12}>
            <a href="/" className="customizeNotifications">
              Customize Your Notifications
            </a>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <List
              dataSource={tableData}
              renderItem={(item, index) => (
                <List.Item key={index}>
                  <i className="fa-solid fa-circle-small"></i>
                  <List.Item.Meta
                    avatar={<Avatar src={item.icon} />}
                    title={item.notificationHeading}
                    description={item.notificationDate}
                  />
                  {index === 2 && <div style={{textAlign:"right"}}>Status: Pending <br />1/1/2023</div>}
                </List.Item>
              )}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Notifications;
